import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "submenuTrigger", "text", 'icon' ]

  connect() {
    this.submenuTriggerTargets.forEach((submenuTrigger) => {
      submenuTrigger.addEventListener("click", (event) => {
        this.toggle(submenuTrigger);
      });
    })
    this.resizeToggleSidebar(this);
    window.addEventListener("resize", () => this.resizeToggleSidebar(this));
  }

  disconnect() {
    this.submenuTriggerTargets.forEach((submenuTrigger) => {
      submenuTrigger.removeEventListener("click", (event) => {
        this.toggle(submenuTrigger);
      });
    })
    window.removeEventListener("resize", () => this.resizeToggleSidebar(this));
  }

  toggle(submenuTrigger) {
    let submenuId = submenuTrigger.id.replace("-submenu-trigger", "");
    let isActive = submenuTrigger.classList.contains("submenu-active");
    let submenuBlock = document.getElementById(`${submenuId}-submenu`);
    isActive ? this.deactivateSubmenu(submenuTrigger, submenuBlock) : this.activateSubmenu(submenuTrigger, submenuBlock);
  }

  activateSubmenu(submenuTrigger, submenuBlock) {
    submenuTrigger.getElementsByClassName('submenu-toggle-icon')[0].classList.replace('fa-angle-right', 'fa-angle-down');
    submenuTrigger.classList.add("submenu-active");
    submenuBlock.classList.add("active");
  }

  deactivateSubmenu(submenuTrigger, submenuBlock) {
    submenuTrigger.getElementsByClassName('submenu-toggle-icon')[0].classList.replace('fa-angle-down', 'fa-angle-right');
    submenuTrigger.classList.remove("submenu-active");
    submenuBlock.classList.remove("active");
  }

  resizeToggleSidebar(that) {
    const sidebar = document.getElementById("sidebar");
    const content = document.getElementById("content");
    const collapsedSidebarNeeded = window.innerWidth <= 1000;
    if (collapsedSidebarNeeded && (sidebar.classList.contains('sidebar-expanded') || sidebar.classList.contains('sidebar-opened'))) {
      that.openCollapseSidebarLogic(sidebar, content, 'collapse', true);
    }
    else if (!collapsedSidebarNeeded && (sidebar.classList.contains('sidebar-closed') || sidebar.classList.contains('sidebar-hidden'))) {
      that.openCollapseSidebarLogic(sidebar, content, 'open', false);
    } else {
      return;
    }
  }

  toggleSidebar() {
    const sidebar = document.getElementById("sidebar");
    const content = document.getElementById("content");
    const isMobile = window.innerWidth <= 1000;
    if (isMobile) {
      if(sidebar.classList.contains('sidebar-opened')) {
        this.openCollapseSidebarLogic(sidebar, content, 'collapse', isMobile);
      } else {
        this.openCollapseSidebarLogic(sidebar, content, 'open', isMobile);
      }
    } else {
      if(sidebar.classList.contains('sidebar-expanded')) {
        this.openCollapseSidebarLogic(sidebar, content, 'collapse', isMobile);
      } else {
        this.openCollapseSidebarLogic(sidebar, content, 'open', isMobile);
      }
    }
  }

  openCollapseSidebarLogic(sidebar, content, openOrCollapse = 'collapse', mobile = false) {
    if (openOrCollapse === 'collapse') {
      this.collapseSidebar(sidebar, content, mobile);
    } else {
      this.openSidebar(sidebar, content, mobile);
    }
    let addOrRemove = openOrCollapse === 'collapse' ? 'add' : 'remove';
    Array.from([
      'sidebar-item', 'sidebar-item-wrapper', 'sidebar-menu-item-wrapper',
      'submenu-toggle-icon', 'sidebar-bottom-wrapper', 'group']
    ).forEach((elementClass) => {
      this.removeOrAddCollapseClass(elementClass, addOrRemove);
    });
    this.iconTargets.forEach((icon) => {
      openOrCollapse === 'collapse' ? icon.classList.remove('mr-2') : icon.classList.add('mr-2');
    });
  }

  collapseSidebar(sidebar, content, mobile = false) {
    const newSidebar = mobile ? 'sidebar-hidden' : 'sidebar-closed';
    const newBody = mobile ? 'body-mobile' : 'body-expanded';
    sidebar.classList.replace('sidebar-expanded', newSidebar);
    sidebar.classList.replace('sidebar-opened', newSidebar);
    content.classList.replace('body-small', newBody);
    content.classList.replace('body-none', newBody);
    sidebar.getElementsByClassName('sidebar-logout-wrapper')[0].style.display = 'none';
    sidebar.getElementsByClassName('full-onestep-logo')[0].style.display = 'none';
    sidebar.getElementsByClassName('small-onestep-logo')[0].style.display = 'block';
    sidebar.getElementsByClassName('sidebar-bubble-small')[0].style.display = 'block';
    sidebar.getElementsByClassName('sidebar-bubbles-full')[0].style.display = 'none';
    this.textTargets.forEach((text) => { text.style.display = 'none' });
    document.getElementsByClassName('sidebar-toggle-icon')[0].classList.replace('fa-arrow-left', 'fa-arrow-right');
  }

  openSidebar(sidebar, content, mobile = false) {
    const newSidebar = mobile ? 'sidebar-opened' : 'sidebar-expanded';
    const newBody = mobile ? 'body-none' : 'body-small';
    sidebar.classList.replace('sidebar-closed', newSidebar);
    sidebar.classList.replace('sidebar-hidden', newSidebar);
    content.classList.replace('body-expanded', newBody);
    content.classList.replace('body-mobile', newBody);
    sidebar.getElementsByClassName('sidebar-logout-wrapper')[0].style.display = '';
    sidebar.getElementsByClassName('full-onestep-logo')[0].style.display = 'block';
    sidebar.getElementsByClassName('small-onestep-logo')[0].style.display = 'none';
    sidebar.getElementsByClassName('sidebar-bubble-small')[0].style.display = 'none';
    sidebar.getElementsByClassName('sidebar-bubbles-full')[0].style.display = 'block';
    this.textTargets.forEach((text) => { text.style.display = '' });
    document.getElementsByClassName('sidebar-toggle-icon')[0].classList.replace('fa-arrow-right', 'fa-arrow-left');
  }

  removeOrAddCollapseClass(elementClass, addOrRemove = 'add') {
    Array.from(document.getElementsByClassName(elementClass)).forEach((item) => {
      addOrRemove === 'add' ? item.classList.add('collapsed') : item.classList.remove('collapsed') ;
    });
  }
}